export const NAME_FIELD_MAX_LENGTH = 35
export const MAP_ID = "9a11729b29e680634e27dc93"
